<template>
  <div class="page">
    <div class="page-title">Checkout Options</div>
    <DoublePane class="checkout-options" :paneState="paneState">
      <template v-slot:left-pane>
        <div class="pane-a">
          <div class="text-center">
            <button class="btn w-100" @click.prevent="onCreate">
              Create New
            </button>
          </div>
          <hr />
          <!-- List of options -->
          <div
            v-for="(option, i) in checkoutOptions"
            :key="`option-${i}`"
            class="text-center mb-2"
          >
            <button class="btn w-100" @click.prevent="onSelect(option)">
              {{ option.label }}
            </button>
          </div>
          <div v-if="!checkoutOptions.length" class="text-center">
            No checkout options found.
          </div>
          <error-panel :errors="[error]"></error-panel>
        </div>
      </template>
      <template v-slot:right-pane>
        <div class="pane-b">
          <h3>
            Checkout Options are presented to customers when they are purchasing
            labels.
          </h3>
          <div v-if="selectedCheckoutOption">
            <CheckoutOptionForm
              :checkoutOption="selectedCheckoutOption"
              @clearSelected="selectedCheckoutOption = null"
            />
          </div>
          <div v-else>Please select a checkout option.</div>
        </div>
      </template>
      <template v-slot:back-button>
        <button class="btn back-btn" @click.prevent="paneState = 0">
          <i class="material-icons">navigate_before</i>
          <div>Back</div>
        </button>
      </template>
    </DoublePane>
  </div>
</template>

<script>
import DoublePane from "@/layouts/DoublePane.vue";
import CheckoutOption from "@/models/CheckoutOption";
import CheckoutOptionForm from "@/components/founder/CheckoutOptionForm";

export default {
  name: "checkout",
  components: {
    DoublePane,
    CheckoutOptionForm,
  },
  data: () => ({
    isLoading: false,
    error: "",
    selectedCheckoutOption: null,
    paneState: 0,
  }),
  methods: {
    onCreate() {
      this.selectedCheckoutOption = new CheckoutOption();
      this.paneState = 1;
    },
    onSelect(option) {
      this.selectedCheckoutOption = option;
      this.paneState = 1;
      console.log(this.selectedCheckoutOption);
    },
  },
  computed: {
    checkoutOptions() {
      return this.$store.state.founder.checkoutOptions;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("loadCheckoutOptions");
    } catch (e) {
      console.log("Error: ", e);
      this.error = "Failed to load checkout options.";
    }
  },
};
</script>

<style lang="scss" scoped>
.checkout-options {
  // margin: auto;
  // margin-top: 15px;
  // max-width: 360px;

  @media screen and (min-width: 768px + 250px + 50px) {
    // max-width: 768px;
  }

  display: flex;
  flex-direction: row;
}

.pane-a {
  padding: 20px;
}

.pane-b {
  padding: 20px;
}
</style>
